// extracted by mini-css-extract-plugin
export default {"FAQ":"FAQ_FAQ__8kE+E"};